import type {AiChatSource, ChatMode, ChatType} from '@Components/ai-chat-window/ai-chat-window.types';

import type {RecommendedTemplate} from '@Components/ai-chat-window/components/assistant-message-image-part-action-tiles/components/templates-for-inspiration-tile/templates-for-inspiration-tile.types';

export const AI_CHAT_HOME_SCROLL_ID = 'ai-chat-home-scroll-container';
export const AI_CHAT_PROMPT_BOX_ID = 'ai-chat';
export const AI_CHAT_QUICK_TIPS_URL_SEGMENT = 'quickTips';
export const AI_CHAT_ROOT_URL_SEGMENT = 'chat';

export interface HistoryItem {
  idAiChat: string;
  title?: string;
  assetHashedFilename?: string;
  type: ChatType;
  mode: ChatMode;
  updatedAt: number;
  source?: AiChatSource | null;
}

export interface RecommendedTemplatesData {
  templates: RecommendedTemplate[];
  templateSearchTerm: string | null;
}
